var map = {
	"./ico-circle.png": 663,
	"./ico-marker.png": 664,
	"./ico-note.png": 665,
	"./ico-polygon.png": 666,
	"./ico-polyline.png": 667,
	"./ico-rectangle.png": 668,
	"./ico-wms.png": 669
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 399;